import React from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { MAINAPIURL, MAINVERSION, SYSTEMNAME } from '../appsettings';
import { tokenService } from '../../services/tokenService';

const Authlogin = () => {
  const ApiURL = MAINAPIURL;
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(false);

  const onFinish = (values) => {
    const { username, password } = values;

    if (!username) return toast.error("Please Enter Username.");
    if (!password) return toast.error("Please Enter Password.");

    setLoading(true);

    axios
      .post(
        `${ApiURL}/user/accessvalidate.php`,
        {
          username: username.trim(),
          userpass: password.trim(),
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      )
      .then((response) => {
        const dataset = response.data;
        if (dataset.status === "error") toast.error(dataset.message);
        else {
          localStorage.setItem("APIURL", ApiURL);
          tokenService.setAccessToken(dataset.access_token);
          localStorage.setItem("USERID", dataset.userid);
          localStorage.setItem("USERDPNAME", dataset.displayname);
          localStorage.setItem("USERROLE", dataset.userrole);
          navigate("/dash");
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Something went wrong");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "linear-gradient(to bottom right, #35bbd8, #0a6ebd)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 12px 35px rgba(0,0,0,0.18)",
          padding: 32,
          animation: "fadeIn 0.4s ease",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{
            display:"flex",
            flexDirection:"column",
            justifyContent:"center",
            alignItems:"start",
            marginLeft:16
          }}>
            <Typography.Title level={4} style={{ marginBottom: 0 }}>
              {SYSTEMNAME}
            </Typography.Title>
            <Typography.Text type="secondary">Version {MAINVERSION}</Typography.Text>
          </div>
          <img src="/sitelogo.png" alt="company logo" style={{ width: "70px", background: "#fff", padding: "4px 8px", borderRadius: "10px", boxShadow: "0px 2px 8px rgba(0,0,0,0.12)" }} />
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Please Enter Username' }]}>            
            <Input size="large" placeholder="Username" />
          </Form.Item>

          <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Please Enter Password' }]}>           
            <Input.Password
              size="large"
              placeholder="Password"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          <Button
            type="primary"
            block
            size="large"
            htmlType="submit"
            loading={loading}
            style={{ height: 48, fontSize: 16, fontWeight: 600, background: "#0a6ebd", borderColor: "#0a6ebd" }}
          >
            Login
          </Button>
        </Form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Authlogin;